export default class UserPropertyRule {
	constructor (user) {
		this.user = user
	}

	checkRule (rule) {
		if (!(rule.property_key in this.user)) {
			return false
		}

		switch (rule.expression_type) {
		case '=':
			return this._checkEqual(rule)
		case '!=':
			return !this._checkEqual(rule)
		case 'contains':
			return this._checkContains(rule)
		case '!contains':
			return !this._checkContains(rule)
		case 'regExp':
			return this._checkRegExp(rule)
		case '!regExp':
			return !this._checkRegExp(rule)
		case 'startsWith':
			return this._checkStartsWith(rule)
		case '!startsWith':
			return !this._checkStartsWith(rule)
		case 'endsWith':
			return this._checkEndsWith(rule)
		case '!endsWith':
			return !this._checkEndsWith(rule)
		}

		return false
	}

	_checkEqual (rule) {
		return (rule.property_value === this.user[rule.property_key])
	}

	_checkContains (rule) {
		return this.user[rule.property_key].includes(rule.property_value)
	}

	_checkRegExp (rule) {
		let regex = new RegExp(rule.property_value, 'gmi')
		return regex.test(this.user[rule.property_key])
	}

	_checkStartsWith (rule) {
		let regex = new RegExp(`^(${rule.property_value})`, 'gmi')
		return regex.test(this.user[rule.property_key])
	}

	_checkEndsWith (rule) {
		let regex = new RegExp(`(${rule.property_value})$`, 'gmi')
		return regex.test(this.user[rule.property_key])
	}
}



// WEBPACK FOOTER //
// ./src/common/components/Onboarding/RuleChecker/UserPropertyRule.js